export default __webpack_public_path__ + "static/media/make-in-india-logo.a40b1325.png";